import { LABEL_FILTROS } from '@/config/label-filtros'
import { FORMAS_DE_PAGO } from '@/config/facturae/formas-de-pago'
import { TIPOS_CUENTA } from '@/config/tipos-cuenta'
import { MONEDA_OPERACION } from '@/config/facturae/moneda-operacion'
import { TIPOS_CODIGO_IMPUESTO } from '@/config/facturae/tipos-codigo-impuesto'
import { TIPOS_ASOCIADOS_IVA, TIPOS_ASOCIADOS_IGIC, TIPOS_ASOCIADOS_IPSI } from '@/config/facturae/tipos-asociados'
import { TIPOS_FISCALIDAD_ESPECIAL } from '@/config/facturae/tipos-fiscalidad-especial'
import { TIPOS_PERSONA } from '@/config/facturae/tipos-persona'
import { TIPOS_RESIDENCIA } from '@/config/facturae/tipos-residencia'
import { TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B } from '@/config/facturae/tipos-rol-administrative-center-fb2b'
import { TIPOS_ROL_ADMINISTRATIVE_CENTER } from '@/config/facturae/tipos-rol-administrative-center'
import { TIPOS_ROL_AGENDA } from '@/config/facturae/tipos-rol-agenda'
import { TIPOS_UNIDADES_MEDIDA } from '@/config/facturae/tipos-unidades-medida'
import { ACCIONES_EMPRESAS } from '@/config/acciones-empresas'
import { DIRE_PREFIX } from '@/config/dire-prefix'
import { TIPOS_IDIOMA } from '@/config/idioma'
import { MESES_USER_PASS_CADUC } from '@/config/meses-user-pass-caduc'
import { OPERADORES } from '@/config/operadores'
import { PAISES } from '@/config/paises'
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { TIPOS_AVISO } from '@/config/tipos-aviso'
import { TIPOS_CERT } from '@/config/tipos-cert'
import { TIPOS_CONDICION } from '@/config/tipos-condicion'
import { TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO } from '@/config/tipos-distribuidor-provisionamiento'
import { TIPOS_DISTRIBUIDOR } from '@/config/tipos-distribuidor'
import { CABECERAS_MODULOS, MODULOS, TIPOS_ESTADO, TIPOS_ESTADO_RECEPCION, TIPOS_ESTADO_VERIFACTU, TIPOS_ACCION, TIPOS_OPERACION, TIPOS_CABECERA } from '@/config/tipos-estado'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import { TIPOS_INVOICE_CLASS } from '@/config/tipos-invoice-class'
import { TIPOS_FACTURA } from '@/config/tipos-factura'
import { TIPOS_CORRECTION_METHOD } from '@/config/tipos-correction-method'
import { TIPOS_METADATOS } from '@/config/tipos-metadato'
import { TIPOS_METADATOS_CREACION } from '@/config/tipos-metadatos-creacion'
import { TIPOS_OTP } from '@/config/tipos-otp'
import { TIPOS_PGE, TIPOS_PGE_RECEPCION } from '@/config/tipos-pge'
import { TIPOS_PLATAFORMA } from '@/config/tipos-plataforma'
import { TIPOS_SERVICIO } from '@/config/tipos-servicio'
import { TIPOS_TBAI_REGIMEN, TIPOS_TBAI_OPERACION, TIPOS_TBAI_NO_EXENTA, TIPOS_TBAI_NO_SUJETA, TIPOS_HACIENDA, TIPOS_ESTADOS_TBAI } from '@/config/tipos-tbai-config'
import { TIPOS_WEBHOOK_NOTIFICATION, TIPOS_WEBHOOK_EVENT, TIPOS_WEBHOOK_AUTH } from '@/config/tipos-webhook'
import { DASHBOARD_LICENCIAMIENTO } from '@/config/dashboard-licenciamiento'

const getDefaultState = () => ({ lastUsed: {}, cache: {} })
  
const state = getDefaultState()
  
const getters = {
  LABEL_FILTROS,
  FORMAS_DE_PAGO,
  TIPOS_CUENTA,
  MONEDA_OPERACION,
  TIPOS_CODIGO_IMPUESTO,
  TIPOS_ASOCIADOS_IVA,
  TIPOS_ASOCIADOS_IGIC,
  TIPOS_ASOCIADOS_IPSI,
  TIPOS_FISCALIDAD_ESPECIAL,
  TIPOS_PERSONA,
  TIPOS_RESIDENCIA,
  TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B,
  TIPOS_ROL_ADMINISTRATIVE_CENTER,
  TIPOS_ROL_AGENDA,
  TIPOS_UNIDADES_MEDIDA,
  ACCIONES_EMPRESAS,
  DIRE_PREFIX,
  TIPOS_IDIOMA,
  MESES_USER_PASS_CADUC,
  OPERADORES,
  PAISES,
  ROLES,
  TIPOS_AUTH,
  TIPOS_AVISO,
  TIPOS_CERT,
  TIPOS_CONDICION,
  TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO,
  TIPOS_DISTRIBUIDOR,
  CABECERAS_MODULOS,
  MODULOS,
  TIPOS_ESTADO,
  TIPOS_ESTADO_RECEPCION,
  TIPOS_ESTADO_VERIFACTU,
  TIPOS_ACCION,
  TIPOS_OPERACION,
  TIPOS_CABECERA,
  TIPOS_GRUPO,
  TIPOS_INVOICE_CLASS,
  TIPOS_FACTURA,
  TIPOS_CORRECTION_METHOD,
  TIPOS_METADATOS,
  TIPOS_METADATOS_CREACION,
  TIPOS_OTP,
  TIPOS_PGE,
  TIPOS_PGE_RECEPCION,
  TIPOS_PLATAFORMA,
  TIPOS_SERVICIO,
  TIPOS_TBAI_REGIMEN,
  TIPOS_TBAI_OPERACION,
  TIPOS_TBAI_NO_EXENTA,
  TIPOS_TBAI_NO_SUJETA,
  TIPOS_HACIENDA,
  TIPOS_ESTADOS_TBAI,
  TIPOS_WEBHOOK_NOTIFICATION,
  TIPOS_WEBHOOK_EVENT,
  TIPOS_WEBHOOK_AUTH,
  DASHBOARD_LICENCIAMIENTO,
}
  
const mutations = {
  setDefaultState (state) {
    Object.assign(state, getDefaultState())
  },
  setConfig (state, { configName, configData }) {
    state.cache[configName] = configData
    state.lastUsed[configName] = Date.now()
  },
  removeConfig (state, configName) {
    delete state[configName]
    delete state.lastUsed[configName]
  },
  extendCacheTime (state, configName) {
    state.lastUsed[configName] = Date.now()
  }
}
  
const actions = {
  cleanConfigCache ({ commit }) {
    commit('setDefaultState')
  },
  checkInactiveConfigs ({ commit, state }) {
    const now = Date.now()
    for (const configName in state.lastUsed) {
      if (now - state.lastUsed[configName] > 600000) { // 10 minutos de inactividad
        commit('removeConfig', configName)
      }
    }
  },
  extendCacheTime ({ commit }, configName) {
    commit('extendCacheTime', configName)
  },
  loadConfig ({ commit }, config) {
    commit('setConfig', config)
  }
}
  
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
